export default __webpack_public_path__ + "static/media/pNouns_grid-4x4.0f06c16a.png";